import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { BoxForm, FormControlDefault, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { createEntity, getEntity, reset, updateEntity } from './inspection-item.reducer';

export const InspectionItemUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const inspectionItemEntity = useAppSelector(state => state.inspectionItem.entity);
  const loading = useAppSelector(state => state.inspectionItem.loading);
  const updateSuccess = useAppSelector(state => state.inspectionItem.updateSuccess);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });

  const handleClose = () => {
    props.history.goBack();
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (!loading && !isNew) {
      setFormData({
        name: inspectionItemEntity.name,
        description: inspectionItemEntity.description,
      });
    }
  }, [loading, isNew, inspectionItemEntity]);

  const saveEntity = values => {
    const entity = {
      ...inspectionItemEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleSubmit = () => {
    event.preventDefault();
    saveEntity(formData);
  };

  return (
    <ThemeProvider theme={theme}>
      <RegisterLayout>
        <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
          <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.inspectionItem'} />
          <Box>
            {loading ? (
              <Box>
                <Typography>Loading...</Typography>
              </Box>
            ) : (
              <Box margin={'0 auto'} width={'100%'}>
                <BoxForm onSubmit={handleSubmit}>
                  {!isNew && (
                    <FormControlDefault sx={{ display: 'none' }}>
                      <TypographyForms>{translate('global.field.id')}</TypographyForms>
                      <TextFieldForms value={formData['id']} id={'inspection-item-id'} name={'id'} />
                    </FormControlDefault>
                  )}

                  <FormControlDefault variant={'outlined'}>
                    <TypographyForms>{translate('fleetSenseApp.inspectionItem.name')}</TypographyForms>
                    <TextFieldForms
                      value={formData['name']}
                      id={'inspection-item-name'}
                      data-cy={'name'}
                      name={'name'}
                      required={true}
                      onChange={e => handleInputChange('name', e.target.value)}
                    />
                  </FormControlDefault>
                  <FormControlDefault variant={'outlined'}>
                    <TypographyForms>{translate('fleetSenseApp.inspectionItem.description')}</TypographyForms>
                    <TextFieldForms
                      value={formData['description']}
                      id={'fleetSenseApp.inspectionItem-description'}
                      data-cy={'description'}
                      name={'description'}
                      onChange={e => handleInputChange('description', e.target.value)}
                    />
                  </FormControlDefault>
                  <RegisterButton disabled={false} />
                </BoxForm>
              </Box>
            )}
          </Box>
        </Box>
      </RegisterLayout>
    </ThemeProvider>
  );
};

export default InspectionItemUpdate;
